export default "__VITE_ASSET__6pERlF5M__"